// src/components/TopBanner.js
import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { getTopBannerMessages } from "../services/topBanner.api";

function TopBanner() {
  const { lang } = useContext(LanguageContext);

  const [messages, setMessages] = useState([]);
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  // ✅ Fetch messages from backend
  useEffect(() => {
    getTopBannerMessages()
      .then((rows) =>
        setMessages(
          rows.map((r) => (lang === "EN" ? r.message_en : r.message_ar))
        )
      )
      .catch(() => {});
  }, [lang]);

  // ✅ Rotate messages
  useEffect(() => {
    if (!messages.length) return;

    const timer = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length);
        setFade(true);
      }, 300);
    }, 4000);

    return () => clearInterval(timer);
  }, [messages]);

  return (
    <div
      className="
        w-full text-center
        bg-cover bg-center
        py-1
        relative
      "
      style={{
        backgroundImage: "url('/images/topBanner.jpg')",
        color: "#ffffff",
      }}
    >
      {/* subtle dark overlay */}
      <div className="absolute inset-0 bg-black/30" />

      <span
        className={`
          relative z-10
          inline-block
          font-semibold
          tracking-wide
          transition-opacity duration-300
          ${fade ? "opacity-100" : "opacity-0"}
        `}
        style={{
          fontSize: lang === "AR" ? "11px" : "10px",
          direction: lang === "AR" ? "rtl" : "ltr",
        }}
      >
        {messages[index]}
      </span>
    </div>
  );
}

export default TopBanner;
